var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('h1',{staticClass:"hero__headline text-mask"},[_c('mark',{staticClass:"mask-text"},[_vm._v(_vm._s(_vm.headline))])])])}
var staticRenderFns = []

export { render, staticRenderFns }